import { utils } from 'pixijs/core';
import { AlphaFilter } from 'pixijs/filter/alpha';
import { BlurFilter, BlurFilterPass } from 'pixijs/filter/blur';
import { ColorMatrixFilter } from 'pixijs/filter/color-matrix';
import { DisplacementFilter } from 'pixijs/filter/displacement';
import { FXAAFilter } from 'pixijs/filter/fxaa';
import { NoiseFilter } from 'pixijs/filter/noise';

/** @deprecated */
const filters = {
    /** @deprecated */
    AlphaFilter,
    /** @deprecated */
    BlurFilter,
    /** @deprecated */
    BlurFilterPass,
    /** @deprecated */
    ColorMatrixFilter,
    /** @deprecated */
    DisplacementFilter,
    /** @deprecated */
    FXAAFilter,
    /** @deprecated */
    NoiseFilter,
};

Object.entries(filters).forEach(([key, FilterClass]) =>
{
    Object.defineProperty(filters, key, {
        get()
        {
            // #if _DEBUG
            utils.deprecation('7.1.0', `filters.${key} has moved to ${key}`);
            // #endif

            return FilterClass;
        },
    });
});

export { filters };
